import { render, staticRenderFns } from "./DescriptionKermel.vue?vue&type=template&id=e4bd1cfc&scoped=true"
import script from "./DescriptionKermel.vue?vue&type=script&lang=js"
export * from "./DescriptionKermel.vue?vue&type=script&lang=js"
import style0 from "./DescriptionKermel.vue?vue&type=style&index=0&id=e4bd1cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bd1cfc",
  null
  
)

export default component.exports